import { Outlet } from 'react-router-dom';

function Otp() {
  return <Outlet />;
}

export default Otp;
